import { Fragment } from 'react';
import styled from 'styled-components';

const PillSelect = ({ name, options, value, onChange }) => (
  <Wrapper>
    {options?.map(option => (
      <Fragment key={option.value}>
        <PillInput
          type="radio"
          name={name}
          id={option.value}
          checked={option.value === value}
          onChange={() => onChange(option.value)}
        />
        <PillLabel htmlFor={option.value}>{option.label}</PillLabel>
      </Fragment>
    ))}
  </Wrapper>
);

const PillInput = styled.input`
  display: none;
`;

const PillLabel = styled.label`
  border-style: solid;
  border-color: #2d7bb4;
  border-radius: 20px;

  padding: 9px 24px;

  font-weight: 400;
  font-size: 16px;

  cursor: pointer;

  /* Change background color when input is checked */
  ${PillInput}:checked + & {
    border-color: #2d7bb4;
    background-color: #2d7bb4;
    color: white;
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: start;
  gap: 4px;

  margin: 4px 0;
`;

export default PillSelect;
